import { mixed, object, string } from 'yup';
import { checkIsraeliPhone } from '../helpers';

export const subCustomersRequestsListSearchValidation = object().shape({
  PrimaryCustomerPhoneNumber: string().test(
    'check-primary-phone',
    'מספר הטלפון לא תקין',
    (value) => (value ? checkIsraeliPhone(value) : true)
  ),
  SubCustomerPhoneNumber: string().test(
    'check-sub-phone',
    'מספר הטלפון לא תקין',
    (value) => (value ? checkIsraeliPhone(value) : true)
  ),
  From: mixed().test('check-from-date', 'טווח התאריכים שגוי', function (value) {
    const to = this.parent.To;
    if (!value || !to) return true;
    return new Date(value as string) <= new Date(to)
      ? true
      : this.createError({ message: 'טווח התאריכים שגוי', path: 'From' });
  }),
  To: mixed().test('check-to-date', 'טווח התאריכים שגוי', function (value) {
    const from = this.parent.From;
    if (!value || !from) return true;
    return new Date(value as string) >= new Date(from)
      ? true
      : this.createError({ message: 'טווח התאריכים שגוי', path: 'To' });
  }),
});
